import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateStudentForm } from '@/features/student/create-student-from/ui/CreateStudentForm'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/students/create')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создание ученика')}>
      <CreateStudentForm onClose={close} />
    </Offcanvas>
  )
}
